import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowRefService {

  constructor(@Inject(PLATFORM_ID) private platformId: object) { }

  
  _window(): any {
      // return the global native browser window object
      return window;
    }


    get nativeWindow(): any {
      if (isPlatformBrowser(this.platformId)) {
        return this._window();
      }
    }
}
